<template>
  <div
    class="player"
    :class="[$store.state.x5videoenterfullscreen ? 'x5fullscreen': '',
     videoIscover ? 'iscover' : '']"
  >
    <dplayer
      :live="live"
      :playUrl="playUrl"
      @waiting="waiting"
      @playing="playing"
      @canplay="canplay"
      @play="play"
      @error="error"
      @pause="pause"
      @ended="ended"
      @stalled="stalled"
      @canplaythrough="canplaythrough"
    />
    <div
      class="restart-btn"
      @click="handleClickReplay"
      v-if="!live && isShowReplay"
    >
      <img
        src="@/assets/icon/replay-icon.png"
        alt=""
      >
      <span>重新播放</span>
    </div>
    <slot></slot>
    <div v-if="resourceState === 1 || resourceState === null">
      <div
        class="consult"
        @click="handleGoConsult"
        v-if="!isPureVersion && $store.state.userInfo.isConsult
          && !excludeUsersForConsult.includes(userId)"
      >咨询医生</div>
    </div>
    <div v-else-if="resourceState === 2 && !isPureVersion" >
      <div
        class="consult"
        :style="{background:'url('+resourceImage+') 0% 0% / 100%'}"
        @click="handleGoConsultPlus"
      ></div>
    </div>
    <div class="bottom-bg"></div>
  </div>
</template>
<script>
import { apiGetResource } from '@/api/app/video/index';
import dplayer from './player.vue';
// 需要屏蔽问诊入口的医生 userId
const excludeUsersForConsult = [
  '271903459117177810',
  '1114076427040282899',
  '1114076605342502874',
  '1114063189217735703',
  '1127587400236086718',
  '1127587402970772928',
  '1127587403328337342',
  '1127587403110233534',
  '1114076606553608153',
  '1127587401211262398',
];
export default {
  name: 'player',
  metaInfo: {
    meta: [
      { name: 'needReload', content: '1' },
    ],
  },
  components: {
    dplayer,
  },
  props: {
    live: {
      type: Boolean,
      default: false,
    },
    playUrl: String,
    iscover: {
      type: Boolean,
      default: false,
    },
    userId: String,
    isPureVersion: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowReplay: false,
      excludeUsersForConsult,
      resourceState: 1, // 资源位类型 0 无 1 医生主页 2 自定义 null 按照1处理
      resourceUrl: '', // 资源位地址
      resourceImage: '', // 资源位图片
    };
  },
  computed: {
    videoIscover() {
      return this.iscover && !this.isPC();
    },
  },
  methods: {
    isPC() {
      const userAgentInfo = navigator.userAgent;
      const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
      let flag = true;
      for (let v = 0; v < Agents.length; v += 1) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    handleGoConsult() {
      this.$player.pause();
      window.location.href = this.$store.state.userInfo.consultUrl;
    },
    handleGoConsultPlus() {
      this.$player.pause();
      window.location.href = this.resourceUrl;
    },
    handleClickReplay() {
      this.$player.play();
    },
    ended() {
      this.isShowReplay = true;
      this.$emit('ended');
    },
    pause() {
      this.$emit('pause');
      const dplayerIcon = document.querySelector('.dplayer-mobile-play');

      if (dplayerIcon) dplayerIcon.style.display = 'block';
    },
    play() {
      this.$emit('play');
    },
    waiting() {
      this.$store.commit('changeSeting', { key: 'isVideoLoading', value: true });
      this.$emit('waiting');
    },
    canplaythrough() {
      this.$emit('canplaythrough');
    },
    playing() {
      this.isShowReplay = false;
      this.$store.commit('changeSeting', { key: 'isVideoLoading', value: false });
      this.$emit('playing');
    },
    canplay() {
      this.$store.commit('changeSeting', { key: 'isVideoLoading', value: false });
      this.$emit('canplay');
    },
    error() {
      this.$emit('error');
    },
    stalled() {
      this.$emit('stalled');
    },
  },
  mounted() {
    const { snowId } = this.$route.query;
    // 获取资源位配置信息
    apiGetResource({ snowId })
      .then((res) => {
        if (res.data) {
          this.resourceState = res.data.resourceState;
          this.resourceUrl = res.data.resourceUrl;
          this.resourceImage = res.data.resourceImage;
        }
      });
    this.$nextTick(() => {
      this.$bridge.emit('showOrHideBar', { showBar: true });
    });
  },
};
</script>
<style lang="less">
.iscover {
  .dplayer-video {
    object-fit: cover;
  }
}
.player {
  position: relative;
  .restart-btn {
    position: absolute;
    background: #333333;
    text-shadow: none;
    font-size: 18px;
    color: #fff;
    padding: 12px 30px;
    border-radius: 20px;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0) ;
    z-index: 100003;
    img {
      width: 20px;
      height: 20px;
      margin-right: 15px;
    }
  }
  .consult {
    color: #fff;
    position: absolute;
    width: 40px;
    height: 40px;
    background: linear-gradient(180deg,#95b7ff, #4f79ff);
    border-radius: 50%;
    font-size: 12px;
    text-align: center;
    padding: 4px;
    line-height: 15px;
    bottom: 120px;
    right: 5px;
    z-index: 100003;
  }
}
.bottom-bg {
  background: url('~@/assets/icon/shadow-bottom.png') repeat-x bottom;
  height: 260px;
  background-size: 100% 100%;
  position: absolute;
  bottom: 0;
  width: 100%;
  z-index: 100001;
}
</style>
